import { addRow } from './table.js'

export const displayEntities = (userTaskID, parentID, elementID, transcriptionText, table, entities, removeEntity) => {
  if (!transcriptionText || !transcriptionText.length) return

  entities.forEach(entity => {
    addRow(userTaskID, parentID, elementID, transcriptionText, entity, table, removeEntity ? entities : null)
  })
}
